// Korean

export default {
  component: {
    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `${date}까지 채용 진행` : ''),
    },
    interview: {
      title: '영상 면접에 대한 답변',
      submit: '답변 전송 및 면접 완료',
      continueLater: '나중에 계속하기',
      startInterview: '면접 시작하기',
      duplicateError: '이미 이 면접에 참여하셨습니다. invitations@recright.com로부터 면접을 계속할 수 있는 링크가 포함된 이메일을 받으셨습니다.',
      confirmSubmitHeader: '일부 면접 질문에 답변하지 않았습니다',
      confirmSubmitContent: '정말 면접을 종료하고 싶으신가요?',
      confirmSubmitContentWarning: '이후에는 답변 작성을 완료할 수 없습니다.',
      submitInterviewHeader: '면접 답변을 제출하세요',
      submitInterviewContent: '정말 면접 답변을 제출하고 면접을 완료하시겠어요?',
      confirmSubmitButton: '답변 전송 및 면접 완료',
      preview: '여기에서 동영상 질문을 미리 보실 수 있습니다.',
      withdrawLink: '이 직책에 더 이상 관심이 없으신가요? 여기에서 진행을 철회하세요,',
    },

    personalInterview: {
      title: '미팅에 적합한 시간 선택',
      description: [
        '미팅에 초대되었습니다.',
        '가장 적합한 시간을 선택하세요.',
      ],
      position: '직책:',
      location: '위치:',
      time: '시간:',
      timezoneNotice: [
        '시간은 지역 시간대로 표시된다는 점을 유의하세요.',
        '현재 귀하의 시간대는 다음과 같습니다:',
        '약속 시간대는 다음과 같습니다:',
      ],
      success: {
        title: '준비 완료!',
        description: '좋습니다! 미팅이 예약되었습니다! 미팅 정보는 다음과 같습니다.',
        linkDescription: [
          '아래 캘린더에 이벤트를 추가할 수 있습니다.',
          '또는 캘린더 앱에 링크를 복사할 수 있습니다,',
        ],
        link: '캘린더에 추가',
      },
    },

    interviewForm: {
      name: '이름',
      city: '거주지',
      email: '이메일',
      phone: '전화번호',
      link: '링크',
      legendBasicInfo: '기본 정보',
      placeholderName: '이름 입력',
      placeholderEmail: '이메일 입력',
      placeholderPhone: '전화번호 입력',
      placeholderCity: '현재 거주지 입력',
      placeholderLink: '링크 추가(예: LinkedIn 프로필).',
      legendAttachments: '첨부 파일',
      legendAdditionalFields: '추가 정보',
      required: '* 별표로 표시된 항목은 필수 항목입니다.',
    },

    sequencedInterview: {
      networkTest: {
        audio: '오디오',
        video: '동영상',
        yes: '예',
        no: '아니오',
        supported: '지원됨',
        quality: '품질',
        header: '네트워크 연결 및 디바이스 테스트',
        description: '이제 네트워크 연결과 면접에 필요한 하드웨어(카메라 및 마이크)가 제대로 작동하는지 확인하기 위해 테스트를 실행합니다. 메시지가 표시되면 테스트에서 카메라와 마이크를 모두 사용하도록 허용하고 카메라가 가려져 있지 않은지 확인하세요. 테스트 진행 시간은 약 30초입니다. 하드웨어 테스트 중에 말을 해보는 것을 권장합니다.',
        inProgress: '테스트 진행 중...',
        networkTestResults: '네트워크 테스트 결과',
        qualityTestResults: '품질 테스트 결과',
        testPassedNetwork: '네트워크 테스트 통과',
        testFailedNetwork: '네트워크 테스트 실패',
        testPassedQuality: '품질 테스트 통과',
        testFailedQuality: '품질 테스트 실패',
        startTest: '테스트 시작',
        startInterview: '면접 시작',
        testAgain: '다시 테스트하기',
        confirmTitle: '면접을 곧 시작합니다',
        confirmWarning: '화상 면접이 시작되면 첫 번째 면접 질문을 볼 수 있는 화면으로 바로 이동합니다. 질문을 본 후 준비하기로 이동합니다',
        confirmText: '각 질문 전에 짧은 시간 동안 답변을 준비할 수 있습니다. 준비가 끝나면 사전 설정된 시간 동안 질문에 답할 수 있습니다. 미리 설정된 답변 시간이 다 되기 전이라도 준비가 되면 바로 답변을 제출할 수 있습니다.',
        confirmText2: '답변을 제출한 후에는 질문이 더 이상 없을 때까지 다음 질문으로 이동합니다.',
        confirmText3: '질문에 대한 답변을 녹화한 후 해당 질문에 대한 재촬영이 허용되는 경우라면 30초 동안 답변을 재촬영할 수 있습니다. 이 30초 이내에 재촬영을 시작하지 않으면 현재 답변이 자동으로 제출되고 다음 문제로 이동합니다.',
        goodLuck: '심호흡을 하면 괜찮아질 겁니다. 행운을 빕니다!',
        qualityRating: {
          excellent: '탁월함',
          good: '우수함',
          fair: '양호함',
          poor: '부족함',
          bad: '열악함',
        },
      },
      questionAnswerView: {
        title: title => `${title} 면접에 답변하기`,
        question: '질문',
        submitAndNext: '제출 및 다음',
        submitAndFinish: '면접 제출 및 완료',
        submitSuccess: '동영상을 성공적으로 제출했습니다!',
        skipText: '녹화 시작',
        stop: '중지',
        retake: '재촬영',
        take: '촬영',
        takesLeft: '회의 재촬영 기회 남음',
        skipTextQuestion: '준비되셨나요? 앞으로 이동하세요',
        retakeConfirmTitle: '이 질문에 대한 답변을 다시 작성하시겠어요?',
        retakeConfirmSubmit: '예, 재촬영을 시작하세요',
        submitInfoForward: '현재 답변을 자동으로 제출하고 앞으로 이동',
        submitInfoForward2: '초',
        nonAnswerableText: '이 메시지는 응답이 필요하지 않습니다. 이 메시지가 닫히면 다음 질문으로 바로 이동합니다.',
        nonAnswerableVideo: '이 동영상에는 답변이 필요하지 않습니다. 이 동영상이 끝나면 다음 질문으로 바로 이동합니다.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `질문에 답할 수 있는 시간은 ${answerMinutes}분, ${answerSeconds}초 남았습니다.`,
      },
      publisher: {
        toNextQuestion: timer => `${timer} 후에 다음 질문으로 이동합니다`,
        recordingStarts: timer => `${timer} 후에 녹화를 시작합니다`,
      },
      errors: {
        tooManyConnections: '다른 탭이나 창에 이미 연결된 창이 열려 있기 때문에 이 연결이 끊겼습니다.',
        unsupportedBrowser: '이 작업은 귀하의 브라우저에서 지원되지 않습니다. 다른 브라우저를 사용하세요.',
        networkError: '인터넷에 연결되지 않았습니다.',
        reconnecting: '연결이 중단되었습니다. 다시 연결을 시도합니다.',
        generalError: '오류가 발생했습니다. 페이지를 새로 고친 다음 다시 시도하세요.',
        allowMediaDevicesError: '이 작업 중에 미디어 디바이스(카메라 또는 마이크)를 가져오지 못했습니다. 브라우저에서 카메라와 마이크 사용을 허용했는지 확인하세요.',
        noAvailableDevicesError: '카메라나 마이크를 찾지 못했습니다. 브라우저에서 카메라와 마이크 사용을 허용했는지 확인하고 해당 디바이스가 다른 애플리케이션에서 사용되고 있지는 않은지 확인한 다음 다시 시도하세요.',
        initPublisherError: '오류가 발생하여 작업이 실패했습니다. 브라우저에서 카메라와 마이크 사용을 허용했는지 확인하고 해당 디바이스가 다른 애플리케이션에서 사용되고 있지는 않은지 확인한 다음 다시 시도하세요.',
      },
      browserInfo: {
        browserSupportTitle: '브라우저 지원',
        supportedBrowsers: '이 테스트와 면접은 최신 버전의 Chrome, Firefox, Safari, Edge를 지원합니다.',
        mobileSupported: '모바일에서 지원되는 브라우저',
        android: 'Android: Google Chrome(최근 출시된 버전), Firefox(최근 출시된 버전)',
        iOS: 'iOS: Safari(최근 출시된 버전)',
        latestVersion: '최근 출시된 버전의 브라우저를 사용 중인지 확인하세요. 모든 작업이 원활하게 작동하는지 확인하기 위한 것입니다.',
        freezeInstruction: '동영상 녹화가 시작되지 않거나 녹화 화면이 검은색으로 유지되는 경우 페이지를 새로 고치세요.',
        unsupportedOnIos: 'iOS에서 지원되지 않는 브라우저를 사용하고 있는 것 같습니다. Safari를 사용하세요.',
        ieUnsupported: 'Internet Explorer를 사용 중인 것 같습니다. Internet Explorer는 이 시험 또는 면접에서 지원되지 않는 브라우저입니다. 다른 브라우저를 사용하세요.',
        qualityTestNotSupported: '죄송하지만 사용 중인 브라우저에서는 하드웨어 테스트가 지원되지 않습니다. 오디오 및 동영상 품질을 테스트하지 않고 면접을 계속하거나 다른 브라우저를 사용할 수 있습니다.',
      },
      reconnectSuccess: '성공적으로 다시 연결되었습니다!',
      continue: '계속',
    },

    withdraw: {
      title: '이 직책에 더 이상 관심이 없으신가요?',
      description: '채용 절차 진행을 철회하세요.',
      buttonText: '채용 절차 진행을 철회하세요',
      thankYouTitle: '감사합니다!',
      thankYouText: '채용 절차 진행을 철회하셨습니다.',
      confirm: '정말 채용 절차 진행을 철회하시겠어요?, 철회하시면 이 질문 및 이 직책과 관련된 모든 면접에 답변할 수 없습니다.',
    },
  },

  page: {
    supportLink: 'support@recright.com',

    embeddedProfileInterview: {
      submit: '응답 제출',
      continue: '계속',
      supportCenter: 'Recright Help Center',
      thankYou: '동영상 답변 감사합니다! 조만간 연락드리겠습니다!',
    },

    finished: {
      reopenDescription: '실수로 이 면접을 닫으셨더라도 걱정하지 마세요! 아래 버튼을 클릭하면 면접을 다시 열 수 있습니다!',
      reopenButtonText: '면접 다시 열기',
      title: '면접에 응해주셔서 감사합니다!',
      description1: '좋습니다! 이제 모든 면접 질문에 답변하셨습니다. 답변은 채용 담당자에게 전송되고 있습니다. 다음 소식을 기다려 주세요!',
      descriptionsupport: mailto => `실수로 이 면접을 닫으셨더라도 걱정하지 마세요! ${mailto}에 이메일을 보내 고객 지원팀에 연락해 주시면 면접을 다시 진행하도록 하겠습니다.`,
      descriptionfeedback: '여러분의 경험은 저희에게 매우 중요합니다! 동영상 면접에 응하신 소감을 듣고 싶습니다. 서비스를 어떻게 개선할 수 있을까요? 여기에 의견을 남겨주세요.',
      feedbackbutton: '의견 공유하기',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: '개인 메시지',
    },

    closed: {
      title: '면접이 완료되었거나 면접이 종료되었습니다',
      description: '초대받은 동영상 면접이 이미 종료되었거나 제출이 완료되었습니다.',
      publicTitle: '면접이 종료되었습니다',
      publicDescription: '찾으시던 동영상 면접이 이미 종료되었습니다.',
    },
    saved: {
      title: '동영상 면접이 저장되었습니다!',
      description: '동영상 면접을 계속 진행하려면 이전에 받으신 이메일 링크를 사용하세요. 돌아오시면 이미 녹화된 동영상 답변이 제대로 표시되어 있을 겁니다! 구직 활동에 행운을 빕니다!',
      remember: '면접 답변을 마친 후 잊지 말고 채용 담당자에게 답변을 보내셔야 합니다.',
      deleteHistory: '공용 컴퓨터에서 화상 면접을 진행하는 경우, 잊지 말고 인터넷 검색 기록을 삭제하세요. 그렇게 하면 면접이 안전하게 유지됩니다.',
    },
    unpublished: {
      title: '아직 면접이 시작되지 않았습니다',
      publishTime: publishTime => `이 면접은 ${publishTime}에 열립니다`,
    },
  },
}
